import React, { lazy } from 'react'

const AboutPage = lazy(() => import(/* webpackChunkName: "aboutPage" */ './about'))

const AboutRoute = () => <AboutPage />

export default AboutRoute
